import { render, staticRenderFns } from "./ProductsAdminBlock.vue?vue&type=template&id=d78c137e&scoped=true"
import script from "./ProductsAdminBlock.vue?vue&type=script&lang=js"
export * from "./ProductsAdminBlock.vue?vue&type=script&lang=js"
import style0 from "./ProductsAdminBlock.vue?vue&type=style&index=0&id=d78c137e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78c137e",
  null
  
)

export default component.exports